module.exports = __webpack_public_path__ + "img/icon-cam.2b70304e.svg";